/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";

function AcceptButton({
  children = "Aceptar",
  onClick,
  type,
  disabled = false,
  fullWidth = false,
  sx,
  ...rest
}) {
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onClick}
      type={type}
      disabled={disabled}
      fullWidth={fullWidth}
      sx={{
        height: 48,
        color: "#fff",
        backgroundColor: "#1976d2",
        "&:hover": { backgroundColor: "#115293" },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}

AcceptButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  sx: PropTypes.object,
};

export default AcceptButton;
